import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_2 = { class: "law-firm__field-name w-50" }
const _hoisted_3 = { class: "law-firm__field-value d-flex align-center" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex mt-2"
}
const _hoisted_5 = { class: "d-flex flex-column law-firm__field-value" }

import { onMounted, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { IAsset } from '@/types/store';
import { IUserInfo } from '@/types/store';
import AppCardInfo from '@/components/App/AppCardInfo.vue';
import { IListGrantsParams } from '@/types/API';
import { RAW_ASSETS_STATUSES } from '@/constants/statuses';

// #constants

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewLawFirm',
  setup(__props) {

const { dispatch, getters } = useStore();

// #data
const isLoading = ref<boolean>(false);
const grants = ref([]);

// #computed
const getAsset = computed<IAsset>(() => {
  return getters['getAsset'];
});
const getUser = computed<IUserInfo>(() => {
  return getters['getUser'];
});
const isLiveAuction = computed(() => {
  const { status = '' } = getAsset.value ?? {};
  return status === RAW_ASSETS_STATUSES.LIVE_AUCTION;
});
const assetId = computed<string>(() => {
  const { id = '' } = getAsset.value ?? {};
  return id;
});
const companyId = computed<string>(() => {
  const {
    company = {
      id: ''
    }
  } = getUser.value ?? {};
  const { id = '' } = company ?? {};
  return id;
});
const getCompanyGrant = computed<{
  preBid: { userId: null | string; updatedAt: string | null };
} | null>(() => {
  if (!grants.value.length) {
    return null;
  }
  const {
    companyGrant = {
      preBid: {
        updatedAt: null,
        userId: null
      }
    }
  } = grants.value[0] ?? {};
  return companyGrant;
});
const getPreBidOwner = computed<string | null>(() => {
  if (!getCompanyGrant.value) {
    return null;
  }
  const {
    preBid = {
      userId: null
    }
  } = getCompanyGrant.value ?? {};

  const { userId: preBidUserId = '' } = preBid ?? {};
  const preBidUser = grants.value.find(({ userId = '' }) => {
    return preBidUserId === userId;
  });
  if (!preBidUser) {
    return null;
  }
  const {
    user = {
      firstName: '',
      lastName: ''
    }
  } = preBidUser ?? {};

  const { firstName = '', lastName = '' } = user ?? {};
  return `${firstName} ${lastName}`;
});
const invitieesList = computed<string[]>(() => {
  return grants.value
    .filter(({ access, userId, companyGrant, user }) => {
      const {
        preBid = {
          userId: ''
        }
      } = companyGrant ?? {};
      const { userId: preBidUserId = '' } = preBid ?? {};
      const { email: grantEmail = '' } = user ?? {};
      const { email: currentUserEmail = '' } = getUser.value ?? {};

      return (
        access !== 'owner' &&
        preBidUserId !== userId &&
        currentUserEmail !== grantEmail
      );
    })
    .map(({ user }) => {
      const { firstName = '', lastName = '', email = '' } = user ?? {};
      if (!firstName || !lastName) {
        return email;
      }

      return `${firstName} ${lastName}`;
    });
});

// #methods
const onGetListGrants = async (): Promise<void> => {
  const params: IListGrantsParams = {
    assetId: assetId.value,
    companyId: companyId.value,
    limit: 50,
    nextToken: null
  };

  isLoading.value = true;
  try {
    const { data } = await dispatch('getListGrants', params);
    const {
      listGrants = {
        items: []
      }
    } = data ?? {};
    const { items = [] } = listGrants ?? {};

    grants.value = items;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

// #hooks
onMounted(async () => {
  await onGetListGrants();
});

return (_ctx: any,_cache: any) => {
  return (isLoading.value || (getPreBidOwner.value && invitieesList.value.length))
    ? (_openBlock(), _createBlock(AppCardInfo, {
        key: 0,
        "card-title": "Law Firm Information",
        class: "law-firm",
        loading: isLoading.value
      }, {
        default: _withCtx(() => [
          (getPreBidOwner.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(isLiveAuction.value ? 'Bid created by' : 'Proposal created by'), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(getPreBidOwner.value), 1)
              ]))
            : _createCommentVNode("", true),
          (invitieesList.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "law-firm__field-name w-50" }, "Other invitees", -1)),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invitieesList.value, (user) => {
                    return (_openBlock(), _createElementBlock("div", { key: user }, _toDisplayString(user), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading"]))
    : _createCommentVNode("", true)
}
}

})